module.exports = __webpack_public_path__ + "img/product-one-1.569e0656.png";